import React from "react";

import "css/ColourChip.css";
import Tick from "./Tick";

const ColourChip = ({ src, selected, onClick, text }) => {
    let selectedClass = selected ? " selected" : "";

    let style = {
        backgroundImage: "url(" + src + ")"
    };

    if (/white/i.test(src) && !src) {
        style.backgroundColor = "white";
    }

    return (
        <div className={"ColourChip" + selectedClass}>
            <div className="colour-border" onClick={onClick} style={onClick ? { cursor: "pointer" } : {}}>
                <div className="colour" style={style}>
                    {selected && <Tick />}
                </div>
            </div>
            <span className="name">{text}</span>
        </div>
    );
};

export default ColourChip;



// WEBPACK FOOTER //
// ./src/components/ColourChip.js